<template>
  <div class="text-left">
    <h1>Envoi de ma télédéclaration grace aux informations récoltées</h1>
    <div class="d-flex flex-column flex-sm-row mb-4 mb-sm-0">
      <p>
        Bravo vous avez fait participer suffisemment de consommateurs pour soumettre vos informations sur la rubrique
        <br />
        <b>Plus de produits de qualité et durables dans nos assiettes.</b>
      </p>
      <v-spacer></v-spacer>
      <v-btn large color="primary" @click="submitDeclaration" class="my-8">
        Soumission
      </v-btn>
    </div>
    <div class="d-flex flex-column flex-sm-row mb-4 mb-sm-0">
      <p>
        Bravo vous avez atteint le niveau 1 sur 3 grâce à vos actions! Vous pouvez soumettre vos informations sur la
        rubrique
        <br />
        <b>Lutte contre le gaspillage alimentaire et dons alimentaires".</b>
      </p>
      <v-spacer></v-spacer>
      <v-btn large color="primary" @click="submitWasteInfo" class="my-8">
        Soumission
      </v-btn>
    </div>
    <div class="d-flex flex-column flex-sm-row mb-4 mb-sm-0">
      <p>
        Désolé vous n'avez pas suffisement communiqué sur vos belles initiative. Nous vous déconseillons de soumettre
        votre télédeclaration sur la rubrique
        <br />
        <b>Information des usagers et convives.</b>
      </p>
      <v-spacer></v-spacer>
      <v-btn large color="primary" @click="showSuggestions" class="my-8">
        Nos Suggestions
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "OnlineDeclarationPage",
  methods: {
    submitDeclaration() {
      console.log("Déclaration soumise")
      // Ajoutez ici la logique pour traiter la soumission
    },
    submitWasteInfo() {
      console.log("Informations sur le gaspillage soumises")
      // Ajoutez ici la logique pour traiter la soumission des informations sur le gaspillage
    },
    showSuggestions() {
      console.log("Suggestions affichées")
      // Ajoutez ici la logique pour afficher les suggestions
    },
  },
}
</script>

<style scoped>
.text-left {
  text-align: left;
}

.my-8 {
  margin: 2rem 0;
}

.d-flex {
  display: flex;
}

.flex-column {
  flex-direction: column;
}

.flex-sm-row {
  flex-direction: row;
}

.mb-4 {
  margin-bottom: 1rem;
}

.mb-sm-0 {
  margin-bottom: 0;
}
</style>
